import { DocumentNode } from 'graphql';
import { useModal } from 'react-modal-hook';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GetParticipantDataQuery as GetParticipantData } from '__generated__/graphql';

import EditMailOptInsForm from './EditMailOptInsForm';
import EditParticipantForm from './EditParticipantForm';
import UI from '../../../../common/UI';

type Participant = GetParticipantData['project']['participant'];

interface UseEditParticipantProps {
  participant?: Participant;
  refetchQueries?: DocumentNode[];
}

type ParticipantTabState = 'general' | 'mail_permissions';

const useEditParticipantModal = ({
  participant,
  refetchQueries,
}: UseEditParticipantProps) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<ParticipantTabState>('general');

  const [openModal, closeModal] = useModal(
    () => (
      <UI.Modal close={closeModal} maxWidth={600}>
        <UI.Tabs sc={{ border: true }}>
          <UI.Tab
            to=""
            as="span"
            className={activeTab === 'general' ? 'active' : ''}
            onClick={() => setActiveTab('general')}
          >
            {t('general')}
          </UI.Tab>
          <UI.Tab
            to=""
            as="span"
            className={activeTab === 'mail_permissions' ? 'active' : ''}
            onClick={() => setActiveTab('mail_permissions')}
          >
            {t('mail_permissions')}
          </UI.Tab>
        </UI.Tabs>

        <UI.Div sc={{ mt: 4 }}>
          {activeTab === 'general' && (
            <EditParticipantForm
              participant={participant}
              onSuccess={() => { closeModal(); }}
              onClose={closeModal}
              refetchQueries={refetchQueries}
            />
          )}
          {activeTab === 'mail_permissions' && (
            <EditMailOptInsForm participant={participant} />
          )}
        </UI.Div>
      </UI.Modal>
    ),
    [participant, t, activeTab, setActiveTab],
  );

  return [openModal, closeModal];
};

export default useEditParticipantModal;
